export const apiUrl =
  typeof window === 'undefined' ? `${process.env.SERVER_HOST}/api/lackmus` : '/api/lackmus';
